import {
  COMMISSIONS_GET_BRANCH_OFFICES_BEGIN,
  COMMISSIONS_GET_BRANCH_OFFICES_SUCCESS,
  COMMISSIONS_GET_BRANCH_OFFICES_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSIONS_GET_BRANCH_OFFICES_BEGIN:
      return {
        ...state
      }
    case COMMISSIONS_GET_BRANCH_OFFICES_SUCCESS:
      return {
        ...state,
        policies: {
          ...state.policies,
          branchOfficeOptions: action.data
        }
      }

    case COMMISSIONS_GET_BRANCH_OFFICES_FAILURE:
      return {
        ...state
      }
    default:
      return state
  }
}
